var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinks = function SvgLinks(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m3.803 8.031.294.513c.26.453.684.787 1.187.931l1.81.516c.537.153.906.643.906 1.203v1.247c0 .343.194.656.5.809s.5.466.5.81v1.218c0 .488.466.84.934.706a1.47 1.47 0 0 0 1.022-1.056l.088-.35c.131-.528.475-.981.947-1.25l.253-.144c.469-.265.756-.765.756-1.303v-.26a1.5 1.5 0 0 0-.44-1.059l-.123-.121A1.5 1.5 0 0 0 11.379 10h-1.347c-.347 0-.69-.09-.994-.262L7.96 9.122a.65.65 0 0 1-.287-.35c-.1-.3.034-.625.319-.766l.184-.094a.87.87 0 0 1 .666-.046l.725.24a.597.597 0 0 0 .646-.947l-.425-.509a1 1 0 0 1 .01-1.29l.49-.573a1 1 0 0 0 .11-1.146l-.075-.132a6.502 6.502 0 0 0-6.519 4.522M16.5 10c0-1.15-.3-2.231-.825-3.172l-.8.322c-.49.197-.744.744-.578 1.244l.528 1.584c.11.325.375.572.706.653l.91.228q.056-.421.056-.859zM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinks);
export default ForwardRef;